import localForage from 'localforage';

localForage.config({
  name: process.env.REACT_APP_NAME,
});
